import { priorityNames } from './constants'
import { getPriorityColor } from 'utils/helpers'

export const getPriorities = () => {
  const priorities = []
  priorityNames.map(priority =>
    priorities.push({
      name: priority,
      color: getPriorityColor(priority)
    })
  )
  return priorities
}
